import { isPlatformBrowser } from '@angular/common';
import { Component, Input, ViewEncapsulation, Inject, PLATFORM_ID, Injector, OnInit } from '@angular/core';
import { ReviewsSummary } from '@shopping-angular-components/reviews';
import { Module } from 'projects/common/model/ModuleModel';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { AbstractComponent } from '../abstract.component';

export interface ReviewsSummaryModel {
  summary: ReviewsSummary;
  product_id: string;
  product_name: string;
  product_type: string;
  title?: string;
}

@Component({
  selector: 'reviews-summary',
  template: `
    <main-title [data]="module" [moduleId]="module.id" [uniqueId]="module.unique_id" [ngClass]="{'-eva-3-mb-xlg': module.title?.text}"></main-title>
    <reviews class="eva-3-card"
             product="nymeria-gui"
             [flow]="flow"
             [pageviewId]="pageviewId"
             [productId]="module.data.product_id"
             [productName]="module.data.product_name"
             [productType]="module.data.product_type"
             [summary]="module.data.summary"
             [locale]="locale"
             [innerTitle]="module.data.title"
             [showAIReview]="true"
    ></reviews>
  `,
  styleUrls: ['./reviews-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReviewsSummaryComponent extends AbstractComponent implements OnInit {
  public static MODULE_ID: string = 'ReviewsSummaryModule';
  @Input() override module: Module<ReviewsSummaryModel>;
  @Input() override product;
  @Input() override flow;

  locale: string;
  pageviewId: string;

  constructor(injector: Injector, public landing: LandingModelService, @Inject(PLATFORM_ID) private platformId: string) {
    super(injector);
    const landingModel = landing.getLandingModel();
    this.locale = landingModel.language + '-' + landingModel.country;
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.pageviewId = window.upaData.pageview_id;
    }
  }

  getModuleId() {
    return ReviewsSummaryComponent.MODULE_ID;
  }
}
